import {
    mobileScreenWidth,
    smallDesktopScreenWidth,
    smallTabletScreenWidth,
    tabletScreenWidth
} from "@Reducers/constants/screenWidths";

export default function determineScreenWidth() {
    return {
        isMobile: window.innerWidth <= mobileScreenWidth,
        isSmallTablet: window.innerWidth >= mobileScreenWidth && window.innerWidth <= smallTabletScreenWidth,
        isTablet: window.innerWidth >= mobileScreenWidth && window.innerWidth <= tabletScreenWidth,
        isSmallDesktop: window.innerWidth >= tabletScreenWidth && window.innerWidth <= smallDesktopScreenWidth,
    }
}